import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FibuAccount } from "../../../../generated/generated-types";
import { GenericBaseModelDropDown } from "../../../../shared/components/genericBaseModelDropDown";
import { FibuAccountListService } from "../../services/fibu-account-list.service";

/** Formly / list dropdown for Fibu accounts; use optionValue `number` to persist Konto-Nr. */
@Component({
    selector: "app-fibu-account-dropdown",
    templateUrl: "./fibu-account-dropdown.component.html",
    standalone: true,
    imports: [CommonModule],
    providers: [FibuAccountListService],
})
export class FibuAccountDropdownComponent extends GenericBaseModelDropDown<FibuAccount> {

    constructor(service: FibuAccountListService) {
        super(service, "FibuAccount");
    }
}
